import { SideBar } from '../../models/sideBar.model';
import { assets } from './assets.const';

export const accountSideBarConst = {
  MyProfile: 1,
  MyPackages: 2,
  AccountInvoice: 3,
  ChangePassword: 5,
  ActivityLogs: 6,
  Settings: 7,
  SignOut: 8,
  DeleteAccount: 9,
  ChangeLanguage: 10,
  /** Parent-only: MyPackages + AccountInvoice consolidated (see `parentAccountSideBar`). */
  MyPurchases: 11
};

export const tutorCounsellorSideBarConst = {
  MyProfile: 1,
  MyAvailability: 2,
  EarningPayroll: 3,
  ChangePassword: 4,
  ActivityLogs: 5,
  Settings: 6,
  SignOut: 7,
  DeleteAccount: 8,
  ChangeLanguage: 9
};

export const SideBar2Const = {
  Communication: 1,
  Notification: 2,
  HelpSupport: 3,
  CourseBundlePackage: 4
};

export const SideBarTutorConst = {
  Communication: 1,
  // Notification:2,
  HelpSupport: 3
};


/**
 * Student primary nav grouped like version 2 `AppSidebar.tsx`:
 * top (Dashboard, My Journey) → Learn → Manage; secondary stays in `sideBar2`.
 */
export const studentNavV2Top: SideBar[] = [
  {
    text: 'Home',
    path: '/dashboard/dashboard-v2',
    matIcon: 'home',
    isSubMenu: false,
    studentOnly: true,
  },
  {
    text: 'Dashboard',
    path: '/dashboard/student-dashboard',
    matIcon: 'space_dashboard',
    isSubMenu: false,
    studentOnly: true,
  },
  /** Direct top-level entry to the existing Explore Journeys page (previously only reachable via Dashboard/Courses CTAs). */
  {
    text: 'NavExploreJourneys',
    path: '/dashboard/explore-pathways',
    matIcon: 'explore',
    isSubMenu: false,
    studentOnly: true,
  },
  {
    // The AI track was merged into Achievements, so one entry now covers both
    // (it opens on the Pathways tab; the AI tab is one click away).
    text: 'NavAchievements',
    path: '/dashboard/achievements',
    matIcon: 'emoji_events',
    isSubMenu: false,
    studentOnly: true,
  },
  /** Counselling Hub — replaces the old "My Counsellor" list page for students. */
  {
    text: 'NavCounsellingHub',
    path: '/manage-counselling/hub',
    matIcon: 'hub',
    isSubMenu: false,
    studentOnly: true,
  },
  // {
  //   text: 'Sessions',
  //   path: '/manage-session',
  //   img: assets.sessionIcon,
  //   isSubMenu: false
  // }
];

export const studentNavV2Learn: SideBar[] = [
  // {
  //   text: 'Courses',
  //   path: '/manage-courses',
  //   img: assets.coursesIcon,
  //   isSubMenu: false,
  // },
  {
    text: 'Courses',
    path: '/dashboard/courses-v2',
    matIcon: 'auto_stories',
    isSubMenu: false,
    studentOnly: true,
  },
  {
    text: 'Tutoring',
    path: '/manage-tutoring/tutors',
    img: assets.tutoringIcon,
    isSubMenu: false,
  },
];

export const studentNavV2Manage: SideBar[] = [
  // TODO: fold the separate "Calendar" entry below into this "Sessions" page —
  // Sessions should show the list view first, with the calendar view (currently
  // its own /calendar route + manage-calendar component) reachable as a second
  // view from within Sessions, instead of a separate sidebar item.

  //  {
  //       text: 'Session View',
  //       path: '/manage-session',
  //       img: assets.sessionIcon,
  //       isSubMenu: false
  //     },
  //     {
  //       text: 'Calendar View',
  //       path: '/calendar',
  //       img: assets.calendarIcon,
  //       isSubMenu: false,
  //     },
  {
    text: 'Sessions',
    img: assets.sessionIcon,
    isSubMenu: false,
    path: '/manage-session'
  },

  {
    text: 'Resources ',
    path: '/action-plan',
    img: assets.actionIcon,
    isSubMenu: false,
  },
  // {
  //   text: 'NavGuides',
  //   path: '/take-a-tour',
  //   img: assets.guidesIcon,
  //   isSubMenu: false,
  // },
  // {
  //   text: 'Universities Wishlist',
  //   path: '/university-wishlist',
  //   img: assets.customList,
  //   isSubMenu: false,
  //   studentOnly: true,
  // },
  // {
  //   text: 'Scholarship wishlist',
  //   path: '/scholarship-wishlist',
  //   img: assets.customList,
  //   isSubMenu: false,
  //   studentOnly: true,
  // },
];

export const sideBar: SideBar[] = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    img: assets.dashboardIcon,
    isSubMenu: false
  },
  {
    text: 'Students',
    path: '/manage-students',
    img: assets.studentIcon4,
    isSubMenu: false
  },
  {
    text: 'Tutoring',
    path: '/manage-tutoring/tutors',
    img: assets.tutoringIcon,
    isSubMenu: false
  },
  {
    text: 'Counselling',
    path: '/manage-counselling/counsellors',
    img: assets.counsellingIcon,
    isSubMenu: false
  },
  {
    text: 'Sessions',
    path: '/manage-session',
    img: assets.sessionIcon,
    isSubMenu: false
  },
  {
    text: 'Resources ',
    path: '/action-plan',
    img: assets.actionIcon,
    isSubMenu: false
  },
  {
    text: 'Calendar',
    path: '/calendar',
    img: assets.calendarIcon,
    isSubMenu: false
  },
  {
    text: 'Courses',
    path: '/manage-courses',
    img: assets.coursesIcon,
    isSubMenu: false
  },
  {
    text: 'Universities Wishlist',
    path: '/university-wishlist',
    img: assets.customList,
    isSubMenu: false
  },
  {
    text: 'Scholarship wishlist',
    path: '/scholarship-wishlist',
    img: assets.customList,
    isSubMenu: false
  }
];

export const sideBar2: SideBar[] = [
  // {
  //   text: 'Course Bundle Packages',
  //   path: '/manage-package',
  //   img: assets.packagesIcon,
  //   isSubMenu: false,
  //   sideBarId: SideBar2Const.CourseBundlePackage
  // },
  {
    text: 'Messages',
    path: '/chat',
    img: assets.communicationIcon,
    isSubMenu: false,
    sideBarId: SideBar2Const.Communication
  },
  {
    text: 'help&support',
    path: '/support',
    img: assets.supportIcon,
    isSubMenu: false,
    sideBarId: SideBar2Const.HelpSupport
  },
  {
    text: 'NavAICounselor',
    path: '/ai-counselor',
    img: assets.aiCounselorIcon,
    isSubMenu: false,
    studentOnly: true,
    isBotAvatar: true,
  }

];

/** Parent's primary nav — dedicated array (was previously the shared `sideBar`/`sideBar2`). */
export const parentSideBar: SideBar[] = [
  {
    text: 'Dashboard',
    path: '/dashboard',
    img: assets.dashboardIcon,
    isSubMenu: false
  },
  {
    text: 'Sessions',
    path: '/manage-session',
    img: assets.sessionIcon,
    isSubMenu: false
  },
  {
    text: 'Resources ',
    path: '/action-plan',
    img: assets.actionIcon,
    isSubMenu: false
  },
  // {
  //   text: 'NavGuides',
  //   path: '/take-a-tour',
  //   img: assets.guidesIcon,
  //   isSubMenu: false
  // },
];

export const parentSideBar2: SideBar[] = [
  {
    text: 'Messages',
    path: '/chat',
    img: assets.communicationIcon,
    isSubMenu: false,
    sideBarId: SideBar2Const.Communication
  },
  {
    text: 'help&support',
    path: '/support',
    img: assets.supportIcon,
    isSubMenu: false,
    sideBarId: SideBar2Const.HelpSupport
  }
];

export const accountSideBar: SideBar[] = [
  {
    text: 'MyProfile',
    path: '/my-profile',
    img: assets.profileIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.MyProfile
  },
  // Hidden per request: My Packages tab temporarily hidden from student profile sidebar
  // {
  //   text: 'MyPackages',
  //   path: '/manage-tutoring/tutor-package',
  //   img: assets.profileIcon2,
  //   isSubMenu: false,
  //   sideBarId: accountSideBarConst.MyPackages
  // },
  // Hidden per request: Account & Invoices tab temporarily hidden from student profile sidebar
  // {
  //   text: 'Account&Invoices',
  //   path: '/my-profile/account-invoice',
  //   img: assets.profileIcon3,
  //   isSubMenu: false,
  //   sideBarId: accountSideBarConst.AccountInvoice
  // },
  {
    text: 'ChangePassword',
    path: '/my-profile/change-password',
    img: assets.profileIcon5,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ChangePassword
  },
  {
    text: 'Activitylogs',
    path: '/my-profile/activity-logs',
    img: assets.profileIcon6,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ActivityLogs
  },
  {
    text: 'ChangeLanguage',
    path: '/my-profile/change-language',
    img: assets.changeLanguageIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.ChangeLanguage
  },
  {
    text: 'Settings',
    path: '/manage-setting',
    img: assets.settingIcon1,
    isSubMenu: false,
    sideBarId: accountSideBarConst.Settings
  },
  {
    text: 'SignOut',
    path: '/auth/login',
    img: assets.signOutIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.SignOut
  },
  {
    text: 'DeleteAccount',
    path: '/auth/login',
    img: assets.trashIcon,
    isSubMenu: false,
    sideBarId: accountSideBarConst.DeleteAccount
  }

];

/**
 * Parent variant of `accountSideBar`: "My Packages" and "Account & Invoices" are collapsed
 * into a single "My Purchases" entry (client feedback — parents wanted one place for
 * everything they've bought). Students keep the two separate entries above.
 */
export const parentAccountSideBar: SideBar[] = accountSideBar
  .filter(
    (item) =>
      item.sideBarId !== accountSideBarConst.MyPackages &&
      item.sideBarId !== accountSideBarConst.AccountInvoice
  )
  .flatMap((item) =>
    item.sideBarId === accountSideBarConst.MyProfile
      ? [
        item,
        {
          text: 'MyPurchases',
          path: '/my-profile/my-purchases',
          img: assets.profileIcon3,
          isSubMenu: false,
          sideBarId: accountSideBarConst.MyPurchases
        }
      ]
      : [item]
  );

export const tutorCounsellorSideBar: SideBar[] = [
  {
    text: 'MyProfile',
    path: '/tutor/profile',
    img: assets.profileIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.MyProfile
  },
  {
    text: 'MyAvailability',
    path: '/tutor/profile/availability',
    img: assets.profileIcon2,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.MyAvailability
  },
  {
    text: 'Earnings&Payroll',
    path: '/tutor/dashboard/earning',
    img: assets.profileIcon3,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.EarningPayroll
  },
  {
    text: 'ChangePassword',
    path: '/tutor/profile/change-password',
    img: assets.profileIcon5,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ChangePassword
  },
  {
    text: 'Activitylogs',
    path: '/tutor/profile/activity-logs',
    img: assets.profileIcon6,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ActivityLogs
  },
  {
    text: 'ChangeLanguage',
    path: '/tutor/profile/change-language',
    img: assets.changeLanguageIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.ChangeLanguage
  },
  {
    text: 'Settings',
    path: '/tutor/manage-setting',
    img: assets.settingIcon1,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.Settings
  },
  {
    text: 'SignOut',
    path: '/auth/login',
    img: assets.signOutIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.SignOut
  },
  {
    text: 'DeleteAccount',
    path: '/auth/login',
    img: assets.trashIcon,
    isSubMenu: false,
    sideBarId: tutorCounsellorSideBarConst.DeleteAccount
  }

];


export const settingSideBar: SideBar[] = [
  {
    text: 'AboutUs',
    path: '/manage-setting/about-us',
    img: assets.aboutIcon,
    isSubMenu: false
  },
  {
    text: 'Terms&Conditions',
    path: '/manage-setting/term-and-condition',
    img: assets.termIcon,
    isSubMenu: false
  },
  {
    text: 'PrivacyPolicy',
    path: '/manage-setting/privacy-policy',
    img: assets.privacyIcon,
    isSubMenu: false
  },
  {
    text: 'DeletionPolicy',
    path: '/manage-setting/deletion-policy',
    img: assets.trashIcon,
    isSubMenu: false
  },
  {
    text: 'FAQs',
    path: '/manage-setting/faq',
    img: assets.faqIcon,
    isSubMenu: false
  }

];


export const sideBartutor4: SideBar[] = [
  {
    text: 'AboutUs',
    path: '/tutor/manage-setting/about-us',
    img: assets.aboutIcon,
    isSubMenu: false
  },
  {
    text: 'Terms&Conditions',
    path: '/tutor/manage-setting/term-and-condition',
    img: assets.termIcon,
    isSubMenu: false
  },
  {
    text: 'PrivacyPolicy',
    path: '/tutor/manage-setting/privacy-policy',
    img: assets.privacyIcon,
    isSubMenu: false
  },
  {
    text: 'DeletionPolicy',
    path: '/tutor/manage-setting/deletion-policy',
    img: assets.delete_icon1,
    isSubMenu: false
  },
  {
    text: 'FAQs',
    path: '/tutor/manage-setting/faq',
    img: assets.faqIcon,
    isSubMenu: false
  }


];


export const sideBarTutor1: SideBar[] = [
  {
    text: 'Dashboard',
    path: '/tutor/dashboard',
    img: assets.dashboardIcon,
    isSubMenu: false
  },
  // {
  //   text: 'Counselling',
  //   path: '/tutor/counselling',
  //   img: assets.counsellingIcon,
  //   isSubMenu: false
  // },
  {
    text: 'Students',
    path: '/tutor/manage-students',
    img: assets.studentIcon4,
    isSubMenu: false
  },
  {
    text: 'Sessions',
    img: assets.sessionIcon,
    isSubMenu: false,
    path: '/tutor/manage-session',
    // subMenuItems: [
    //   {
    //     text: 'Session View',
    //     path: '/tutor/manage-session',
    //     img: assets.sessionIcon,
    //     isSubMenu: false
    //   },
    //   {
    //     text: 'Calendar View',
    //     path: '/tutor/calendar',
    //     img: assets.calendarIcon,
    //     isSubMenu: false
    //   }
    // ]
  },
  {
    text: 'Resources',
    path: '/tutor/action-plan',
    img: assets.actionIcon,
    isSubMenu: false
  },
  {
    text: 'GuideBook',
    path: '/tutor/guide-book',
    img: assets.resourceIcon,
    isSubMenu: false
  },
  // {
  //   text: 'NavGuides',
  //   path: '/tutor/take-a-tour',
  //   img: assets.guidesIcon,
  //   isSubMenu: false
  // },
  // Courses hidden from both counselor and tutor navigation per client feedback
  // {
  //   text: 'Courses',
  //   path: '/tutor/manage-courses',
  //   img: assets.coursesIcon,
  //   isSubMenu: false,
  //   tutorOnly: true
  // },
  // {
  //   text: 'WishlistUniversities',
  //   path: '/tutor/university-wishlist',
  //   img: assets.customList,
  //   isSubMenu: false
  // },
  // {
  //   text: 'TutorMenuScholarshipWishlist',
  //   path: '/tutor/scholarship-wishlist',
  //   img: assets.customList,
  //   isSubMenu: false
  // },
  // {
  //   text: 'KnowledgeBank',
  //   path: '/tutor/ai-tutor',
  //   img: assets.knowledgeBankIcon,
  //   isSubMenu: false,
  //   //tutorOnly: true
  // },
  // {
  //   text: 'NavAICounselor',
  //   path: '/tutor/ai-counselor',
  //   matIcon: 'smart_toy',
  //   isSubMenu: false,
  // },
];

export const sideBarTutor2: SideBar[] = [
  {
    text: 'Message',
    path: '/chat',
    sideBarId: SideBarTutorConst.Communication,
    img: assets.communicationIcon,
    isSubMenu: false
  },
  // {
  //   text: 'Notifications',
  //   path: '/tutor/manage-notification',
  //   sideBarId:SideBarTutorConst.Notification,
  //   img: assets.notificationIcon,
  //   isSubMenu: false
  // },
  {
    text: 'help&support',
    path: '/tutor/support',
    sideBarId: SideBarTutorConst.HelpSupport,
    img: assets.supportIcon,
    isSubMenu: false
  },
  {
    text: 'NavAICounselor',
    path: '/tutor/ai-counselor',
    img: assets.aiCounselorIcon,
    isSubMenu: false,
    isBotAvatar: true,
  }
];


